/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
const viewPortSizeMappingHorizontal = {
  mobile: [320, 50],
  tablet: [728, 90],
  desktop: [728, 90]
};

const viewPortSizeMappingVertical = {
  mobile: [300, 250],
  tablet: [300, 600],
  desktop: [300, 600]
};

const viewPortSizeMappingSquare = {
  mobile: [300, 250],
  tablet: [300, 250],
  desktop: [300, 250]
};

const viewPortSizeMappingLSquare = {
  mobile: [336, 280],
  tablet: [336, 280],
  desktop: [336, 280]
};

export const sizes = {
  "Horizontal-Ad": viewPortSizeMappingHorizontal,
  Mrec: viewPortSizeMappingSquare,
  "Vertical-Ad": viewPortSizeMappingVertical,
  "Story-Mrec": viewPortSizeMappingSquare,
  "Story-Lrec": viewPortSizeMappingLSquare,
  "Story-Middle-Ad": viewPortSizeMappingHorizontal,
  "Story-Bottom-Ad": viewPortSizeMappingHorizontal
};
